import licenseModule from '../../license.module';

export default licenseModule.component('licensePurchaseListing', {
    template: require('./licensePurchaseListing.component.html'),
    controller: licensePurchaseListingComponent,
    bindToController: true,
    bindings: {
        purchasesHistory: '<'
    }
});

function licensePurchaseListingComponent($filter) {
    var vm = this;
    vm.$onInit = activate;
    vm.$onChanges = change;
    vm.historyList = [];

    function renderPurchasesHistory() {
        if (vm.purchasesHistory != null) {
            vm.purchasesHistory = $filter('orderBy')(
                vm.purchasesHistory,
                'purchaseDate',
                'desc'
            );
        }
    }

    function renderPurchasesHistoryTotal() {
        vm.totalItem = vm.purchasesHistory.length;
        if (vm.totalItem < 2) {
            // when the item less or equal to one (singular)
            vm.unitName = 'item';
        } else {
            // when the item more than one (plural)
            vm.unitName = 'items';
        }
    }

    function activate() {
        // listing title
        vm.theTitle = 'Purchase History';

        vm.options = {
            sortable: true, // Apply Sortable To All Columns, When Table is sortable, dragSort & orderInput should be disabled
            checkBox: 'none', // none,always,onhover(any checkbox is checked, all will appear)
            showHeader: true, // default is show header
            // "maxSelection": 1,
            dragSort: false,
            orderInput: false,
            showHeaderWhenNoData: true,
            paging: false,
            // order: [[4,"desc"]],
            // "paging": {
            // "currentPage": 1,
            // "itemsPerPage": 5
            // },
            // "customClass": "text-right",
            // "rowTemplate": "<td>123456</td><td>123456</td><td>123456</td><td>123456</td><td>123456</td><td>123456</td>",
            // "altRowTemplate": "<td>even row</td><td>even row</td><td>even row</td><td>even row</td><td>even row</td><td>even row</td>",
            columns: [
                {
                    name: 'sku',
                    label: 'SKU'
                    // "template": "<div class='customer-name'>Dear {{item.FirstName}} {{item.LastName}} - Your Salary is {{item.Salary}}</div>"
                    //  "class": "text-right", //Custom Class For Header
                    // "cellClass": "text-left" //Custom Class For Body Cell
                },
                {
                    name: 'details',
                    label: 'Details',
                    class: 'hide-column-md',
                    cellClass: 'hide-column-md',
                    template: "<div class='truncate'>{{item.details}}</div>"
                    // "customSort": function (v1, v2) {
                    // If we don't get strings, just compare by index
                    // if (v1.type !== 'string' || v2.type !== 'string') {
                    // return (v1.index < v2.index) ? -1 : 1;
                    // }

                    // Compare strings alphabetically, taking locale into account
                    // return v1.value.localeCompare(v2.value);
                    // }
                },
                {
                    name: 'quantity',
                    label: 'Quantity',
                    template:
                        "<div class='quantity'>{{item.quantity}} {{item.unit}}</div>"
                },
                {
                    name: 'purchaseDate',
                    label: 'Start Date',
                    template:
                        "<div class='date'>{{item.purchaseDate | daterange: item.purchaseDate:'d'}}</div>"
                    // "visible": false
                }
            ],
            groupActionMenus: ['macros', 'actions'],
            actionMenus: [
                {
                    header: 'macros',
                    showHeader: true,
                    items: [
                        { label: 'Preview Channel', value: 'previewchannel' }
                    ]
                },
                {
                    header: 'actions',
                    showHeader: true,
                    items: [
                        {
                            label: "<i class='item-icon fa fa-copy'></i>Copy",
                            value: 'copy'
                        },
                        {
                            label:
                                "<i class='item-icon fa fa-trash'></i>Delete",
                            value: 'delete'
                        },
                        {
                            label:
                                "<i class='item-icon fa fa-download'></i>Export",
                            value: 'export'
                        }
                    ]
                }
            ]
        };
    }

    function change(changeObj) {
        if (
            changeObj.purchasesHistory.currentValue &&
            changeObj.purchasesHistory.currentValue != null
        ) {
            renderPurchasesHistory();
            renderPurchasesHistoryTotal();
            // vm.showLoading = false;
        }
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-purchase-listing/licensePurchaseListing.component.js